import styled, { keyframes } from 'styled-components';
import {
  IconHammerTimeDown,
  IconHammerTimeUp,
} from '@toolshed/styleguide/components/AppIcon/AppIcons';
import type { IconSize } from '@toolshed/styleguide/components/AppIcon/Icon';
import colors from '../../@toolshed/styleguide/styles/colors';

interface LoaderProps {
  size?: IconSize;
  color?: string;
}

const hammerTime = keyframes`
  0 {
    visibility: visible;
  }

  100% {
    visibility: hidden;
  }
`;

const HammerDown = styled.div<StyledDiv>`
  animation: 0.4s steps(2, start) infinite ${hammerTime};
  position: absolute;
  animation-direction: normal;
`;
const HammerUp = styled.div<StyledDiv>`
  animation: 0.4s steps(2, start) infinite ${hammerTime};
  position: absolute;
  animation-direction: reverse;
`;

const hammerProps = (size?: IconSize, color?: string) => ({
  size,
  transparent: true,
  color: color || colors.blue,
});

const Loader = ({ size, color }: LoaderProps) => (
  <>
    <HammerDown>
      <IconHammerTimeDown {...hammerProps(size, color)} />
    </HammerDown>
    <HammerUp>
      <IconHammerTimeUp {...hammerProps(size, color)} />
    </HammerUp>
  </>
);

export default Loader;
